module.exports = __webpack_public_path__ + "img/bmw.0a368346.png";